import type { DomainMapper } from '../types';

const de: DomainMapper = {
  countryCode: 'de',
  currency: 'EUR',
  dataAreaId: 'de20',
  domain: 'kahrs-stage.iveo.store',
  environment: 'stage',
  flagUrl: '/flags/DE.svg',
  languagePrimary: true,
  locale: 'de',
  logoUrl: 'kahrs-logo',
  noRobots: true,
  sitemapUrl: 'https://kahrs.stage3.iveo.se/storage/sitemaps/sitemap-de.xml',
  storyblokBasePath: 'de',
  url: 'https://kahrs-stage.iveo.store/de',
  algoliaIndex: 'b2b-de-de-DE-products',
  algoliaIndexAutocomplete: 'b2b-de-de-DE-products_query_suggestions',
  algoliaIndexPages: 'content_',
  applicationId: 1351,
  subFolder: true,
  b2b: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: 'b2b',
    applicationId: 1351,
    algoliaIndex: 'b2b-de-de-DE-products',
    algoliaIndexAutocomplete: 'b2b-de-de-DE-products_query_suggestions',
    displayIncVat: false,
    default: true,
    productBasePath: 'b2b/produkt',
    sitemapUrl: 'https://kahrs.stage3.iveo.se/storage/sitemaps/sitemap-de.xml',
  },
  b2c: {
    enabled: false,
    purchaseEnabled: false,
    storyblokBasePath: '',
    applicationId: 1351,
    algoliaIndex: 'b2c-de-de-DE-products',
    algoliaIndexAutocomplete: 'b2c-de-de-DE-products_query_suggestions',
    displayIncVat: true,
    default: false,
    productBasePath: 'produkt',
    sitemapUrl: 'https://kahrs.stage3.iveo.se/storage/sitemaps/sitemap-de-b2c.xml',
    features: {
      enableNorceCheckoutAddressUpdates: true,
    },
  },
  features: {
    fastOrder: true,
    backorders: false,
    cartSettings: true,
    sampleInventory: true,
    disableShipToConsumer: true,
    onlyAllowCustomerEditAddressesForSamples: true,
  },
  norceCdnBaseUrl: 'https://kahrs.stage.cdn-norce.tech',
} as DomainMapper;

export default de;
